import { inject } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';

import { AnalyticsService } from '../../Domain/Port/analytics.service';

/**
 * Sets up tracking for router navigation events and logs navigation data using the AnalyticsService.
 *
 * This function initializes a subscription to the router events, specifically listening for
 * NavigationEnd events. When a navigation ends, the function logs the transition from the
 * previous URL to the next URL.
 *
 * @return {Function} A function that, when executed, subscribes to router navigation events for tracking.
 */
export function setupAnalyticsRouterTracking(): () => void {
    return () => {
        const router = inject(Router);
        const analyticsService = inject(AnalyticsService);

        let previousUrl: string = '';
        router.events.subscribe(event => {
            if (event instanceof NavigationEnd) {
                const from = previousUrl;
                const to = event.urlAfterRedirects;
                analyticsService.logNavigation(from, to).then();
                previousUrl = to;
            }
        });
    };
}
